(function () {
  'use strict';

  function moneyFormat(cents, moneyFormatString) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormatString || window.theme?.moneyFormat || '${{amount}}');
    }

    var value = (Number(cents || 0) / 100).toFixed(2);
    return '$' + value;
  }

  function detectCategory(year) {
    var currentYear = new Date().getFullYear();
    var birthYear = parseInt(year, 10);

    if (!birthYear || birthYear < 1900 || birthYear > currentYear) return '';

    var age = currentYear - birthYear;

    if (age <= 12) return 'Junior';
    if (age <= 15) return 'Senior';
    return 'Masters';
  }

  function initCountdown(root) {
    var countdown = root.querySelector('[data-mf-countdown]');
    if (!countdown) return;

    var targetRaw = countdown.getAttribute('data-target');
    if (!targetRaw) return;

    var target = new Date(targetRaw).getTime();
    if (Number.isNaN(target)) return;

    var daysEl = countdown.querySelector('[data-days]');
    var hoursEl = countdown.querySelector('[data-hours]');
    var minutesEl = countdown.querySelector('[data-minutes]');
    var secondsEl = countdown.querySelector('[data-seconds]');
    var expiredText = countdown.getAttribute('data-expired-text') || 'El torneo ha comenzado';

    function update() {
      var diff = target - Date.now();

      if (diff <= 0) {
        if (daysEl) daysEl.textContent = '00';
        if (hoursEl) hoursEl.textContent = '00';
        if (minutesEl) minutesEl.textContent = '00';
        if (secondsEl) secondsEl.textContent = '00';

        var stock = root.querySelector('[data-mf-stock-text]');
        if (stock) stock.textContent = expiredText;
        return;
      }

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((diff / (1000 * 60)) % 60);
      var seconds = Math.floor((diff / 1000) % 60);

      if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    update();
    setInterval(update, 1000);
  }

  function initEventForm(root) {
    var form = root.querySelector('[data-mf-event-form]');
    if (!form) return;

    var productJsonScript = root.querySelector('[data-mf-product-json]');
    var variantSelect = form.querySelector('[name="id"]');
    var addButton = form.querySelector('[data-mf-add]');
    var errorBox = form.querySelector('[data-mf-error]');
    var categoryInput = form.querySelector('[data-mf-category-input]');
    var categoryOutput = root.querySelector('[data-mf-category-output]');
    var yearInput = form.querySelector('[data-mf-birth-year]');
    var priceEls = root.querySelectorAll('[data-mf-price]');
    var compareEls = root.querySelectorAll('[data-mf-compare]');
    var stockEls = root.querySelectorAll('[data-mf-stock-text]');
    var product = null;

    try {
      product = productJsonScript ? JSON.parse(productJsonScript.textContent) : null;
    } catch (error) {
      product = null;
    }

    function getVariant() {
      if (!product || !product.variants || !variantSelect) return null;

      return product.variants.find(function (variant) {
        return String(variant.id) === String(variantSelect.value);
      });
    }

    function updateVariantUI() {
      var variant = getVariant();
      if (!variant) return;

      priceEls.forEach(function (el) {
        el.textContent = moneyFormat(variant.price, root.getAttribute('data-money-format'));
      });

      compareEls.forEach(function (el) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          el.textContent = moneyFormat(variant.compare_at_price, root.getAttribute('data-money-format'));
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });

      var available = Boolean(variant.available);
      var inventoryText = '';

      if (!available) {
        inventoryText = 'Entradas agotadas';
      } else if (typeof variant.inventory_quantity === 'number' && variant.inventory_management) {
        inventoryText = variant.inventory_quantity > 0
          ? variant.inventory_quantity + ' entradas disponibles'
          : 'Últimas entradas disponibles';
      } else {
        inventoryText = 'Entrada disponible';
      }

      stockEls.forEach(function (el) {
        el.textContent = inventoryText;
      });

      if (addButton) addButton.disabled = !available;
    }

    function setError(message) {
      if (!errorBox) return;

      if (!message) {
        errorBox.textContent = '';
        errorBox.classList.remove('is-active');
        return;
      }

      errorBox.textContent = message;
      errorBox.classList.add('is-active');
    }

    function validate() {
      var requiredFields = form.querySelectorAll('[data-mf-required]');
      var currentYear = new Date().getFullYear();

      for (var i = 0; i < requiredFields.length; i += 1) {
        var field = requiredFields[i];

        if (!String(field.value || '').trim()) {
          return 'Completa todos los datos obligatorios del jugador antes de comprar.';
        }
      }

      var playerId = form.querySelector('[data-mf-player-id]');

      if (playerId && !/^[0-9]{4,12}$/.test(String(playerId.value || '').trim())) {
        return 'El Pokémon Player ID debe tener solo números. Revisa que esté correcto.';
      }

      if (yearInput) {
        var year = parseInt(yearInput.value, 10);

        if (!year || year < 1900 || year > currentYear) {
          return 'El año de nacimiento no es válido.';
        }
      }

      return '';
    }

    function updateCategory() {
      if (!yearInput) return;

      var category = detectCategory(yearInput.value);

      if (categoryInput) categoryInput.value = category;

      if (categoryOutput) {
        categoryOutput.textContent = category || 'Pendiente';
      }
    }

    function submitForm(event) {
      event.preventDefault();

      var error = validate();

      if (error) {
        setError(error);
        return;
      }

      setError('');

      var formData = new FormData(form);

      if (addButton) addButton.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json'
        },
        body: formData
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error(data.description || 'No se pudo agregar la entrada al carrito.');
            });
          }

          return response.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));

          if (window.location.pathname.indexOf('/cart') === -1) {
            window.location.href = '/cart';
          }
        })
        .catch(function (errorCatch) {
          setError(errorCatch.message || 'No se pudo agregar la entrada. Intenta nuevamente.');
        })
        .finally(function () {
          updateVariantUI();
        });
    }

    if (variantSelect) {
      variantSelect.addEventListener('change', updateVariantUI);
    }

    if (yearInput) {
      yearInput.addEventListener('input', updateCategory);
      updateCategory();
    }

    form.addEventListener('submit', submitForm);
    updateVariantUI();
  }

  function initPremierEvents() {
    document.querySelectorAll('[data-mf-premier-event]').forEach(function (root) {
      if (root.dataset.mfInitialized === 'true') return;

      root.dataset.mfInitialized = 'true';

      initCountdown(root);
      initEventForm(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPremierEvents);
  } else {
    initPremierEvents();
  }

  document.addEventListener('shopify:section:load', initPremierEvents);
})();